import PropTypes from "prop-types"
import React from "react"
import classNames from "classnames"
import {
  bottomOfColumn,
  centerOfColumn,
  container,
  footer as footerStyle,
  header as headerStyle,
  mainBody as mainBodyStyle,
  sidebar as sidebarStyle,
  title as titleStyle,
  topOfColumn,
  twoColumnLayout,
} from "./styles.module.scss"
import "../../../common_styling/custom.scss"

const SIDEBAR_POSITION_ON_MOBILE = {
  bottomOfColumn,
  centerOfColumn,
  topOfColumn,
}

function TwoColumn({
  header,
  title,
  mainBody,
  additionalBody,
  sidebar,
  footer,
  sidebarPositionOnMobile,
}) {
  return (
    <div className={classNames(container)}>
      <div className={classNames(headerStyle)}>{header}</div>
      <div
        className={classNames(
          twoColumnLayout,
          SIDEBAR_POSITION_ON_MOBILE[sidebarPositionOnMobile],
        )}
      >
        <div className={classNames(titleStyle)}>{title}</div>
        <div className={classNames(mainBodyStyle)}>{mainBody}</div>
        {additionalBody}
        <div className={classNames(sidebarStyle)}>{sidebar}</div>
      </div>
      <div className={classNames(footerStyle)}>{footer}</div>
    </div>
  )
}

TwoColumn.propTypes = {
  header: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  mainBody: PropTypes.node.isRequired,
  additionalBody: PropTypes.node,
  sidebar: PropTypes.node.isRequired,
  footer: PropTypes.node.isRequired,
  sidebarPositionOnMobile: PropTypes.oneOf([
    "bottomOfColumn",
    "centerOfColumn",
    "topOfColumn",
  ]),
}

TwoColumn.defaultProps = {
  sidebarPositionOnMobile: "bottomOfColumn",
  additionalBody: undefined,
}

export default TwoColumn
